import { MutationTree } from "vuex";
import { WhiteboardState, AlterContentMediaState, initWhiteboardModuleState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<WhiteboardState> = {
  //resetState
  [defineVuexName(MODULES.WHITE_BOARD.COMMITS.RESET_STATE)](s: WhiteboardState) {
    Object.assign(s, initWhiteboardModuleState());
  },
  //setMediaState
  [defineVuexName(MODULES.WHITE_BOARD.COMMITS.SET_MEDIA_STATE)](state: WhiteboardState, payload: AlterContentMediaState) {
    state.mediaState = payload;
    state.shouldFetchMediaState = false;
  },
  //setShouldFetchMediaState
  [defineVuexName(MODULES.WHITE_BOARD.COMMITS.SET_SHOULD_FETCH_MEDIA_STATE)](state: WhiteboardState, payload: boolean) {
    state.shouldFetchMediaState = payload;
  },
};

export default mutations;
